import {TextSmallRegular} from '@hm/fundamental'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, STATUS_ICON_MAP, STATUS_TRANSLATION_KEY_MAP} from '../../consts'
import {Instruction} from '../../types/documents.types'

type DocumentStatusProps = {
  document: Instruction
}

export const DocumentStatus: FC<DocumentStatusProps> = ({document}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <div className="flex flex-col justify-around leading-normal">
      <div className="flex items-center gap-2">
        {STATUS_ICON_MAP[document.status]} {t(STATUS_TRANSLATION_KEY_MAP[document.status])}
      </div>
      {document.deleteDayCounter && (
        <TextSmallRegular className="ml-6 whitespace-nowrap">
          {t('documents.label.deletedIn', {
            days: document.deleteDayCounter
          })}
        </TextSmallRegular>
      )}
    </div>
  )
}
